
import React from 'react';
import { Sparkles, Github, Twitter, Linkedin, Heart } from 'lucide-react';


// Footer Component
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black/40 backdrop-blur-xl border-t border-white/10 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="relative">
                <Sparkles className="w-6 h-6 text-purple-400" />
                <div className="absolute inset-0 blur-lg bg-purple-400 opacity-50" />
              </div>
              <h3 className="text-lg font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                PromptStudio
              </h3>
            </div>
            <p className="text-gray-400 text-sm">
              Créez des prompts marketing de qualité en quelques secondes.
            </p>
          </div>

          {/* Features Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Fonctionnalités</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Générateur de Prompts
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Historique
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Modèles
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Documentation
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Ressources</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Tutoriels
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Support
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Légal</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Confidentialité
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Conditions
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Cookies
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors">
                  Mentions légales
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 my-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Copyright */}
          <div className="flex items-center space-x-2 text-gray-400 text-sm mb-4 md:mb-0">
            <span>© {currentYear} PromptStudio. Tous droits réservés.</span>
            <Heart className="w-4 h-4 text-pink-500 fill-pink-500" />
          </div>

          {/* Social Links */}
          <div className="flex items-center space-x-4">
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-white/5 hover:bg-purple-500/20 rounded-lg transition-colors text-gray-400 hover:text-purple-400"
              title="GitHub"
            >
              <Github className="w-5 h-5" />
            </a>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-white/5 hover:bg-purple-500/20 rounded-lg transition-colors text-gray-400 hover:text-purple-400"
              title="Twitter"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-white/5 hover:bg-purple-500/20 rounded-lg transition-colors text-gray-400 hover:text-purple-400"
              title="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
